import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swpright",
  "use": "icon-swpright-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-swpright\"><path d=\"M332.33 185.173a42.667 42.667 0 0 0 3.926 60.246L640 511.957l28.16-32.085L640 512 335.317 778.581a42.667 42.667 0 0 0 56.192 64.256l304.683-266.624a85.333 85.333 0 0 0 0.085-128.341L392.533 181.248a42.667 42.667 0 0 0-60.202 3.925z\" p-id=\"8877\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol